import { render, staticRenderFns } from "./DayCalendar.vue?vue&type=template&id=ffe8ca72"
import script from "./DayCalendar.vue?vue&type=script&lang=js"
export * from "./DayCalendar.vue?vue&type=script&lang=js"
import style0 from "./DayCalendar.vue?vue&type=style&index=0&id=ffe8ca72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports